var _Line, _Line2, _Line3, _Line4, _Line5, _Line6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import Svg, { Line } from "react-native-svg";
var SvgList = function SvgList(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-list"
  }, props), _Line || (_Line = /*#__PURE__*/React.createElement(Line, {
    x1: 8,
    y1: 6,
    x2: 21,
    y2: 6
  })), _Line2 || (_Line2 = /*#__PURE__*/React.createElement(Line, {
    x1: 8,
    y1: 12,
    x2: 21,
    y2: 12
  })), _Line3 || (_Line3 = /*#__PURE__*/React.createElement(Line, {
    x1: 8,
    y1: 18,
    x2: 21,
    y2: 18
  })), _Line4 || (_Line4 = /*#__PURE__*/React.createElement(Line, {
    x1: 3,
    y1: 6,
    x2: 3.01,
    y2: 6
  })), _Line5 || (_Line5 = /*#__PURE__*/React.createElement(Line, {
    x1: 3,
    y1: 12,
    x2: 3.01,
    y2: 12
  })), _Line6 || (_Line6 = /*#__PURE__*/React.createElement(Line, {
    x1: 3,
    y1: 18,
    x2: 3.01,
    y2: 18
  })));
};
export default SvgList;